import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StateService } from '../../../../services/state.service';
import { EditorConfigurationProvider } from '../../../../services/editor-configuration.provider';
import { RsEditorConfigurationProvider } from '../../../../services/rs-editor-configuration.provider';

@Component({
  selector: 'app-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
})
export class SettingsMenuComponent implements OnDestroy {
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Input() visible: boolean;

  isRS: boolean;
  devModeAvailable = false;
  superEditModeAvailable = false;

  devModeControl: FormControl;
  superEditModeControl: FormControl;
  supportModeControl: FormControl;
  hiddenFieldsModeControl: FormControl;

  subscriptions = new Subscription();

  constructor(
    private stateService: StateService,
    private cdRef: ChangeDetectorRef,
    editorConfigurationProvider: EditorConfigurationProvider,
    private rsConfig: RsEditorConfigurationProvider
  ) {
    this.devModeControl = new FormControl(false);
    this.superEditModeControl = new FormControl(false);
    this.supportModeControl = new FormControl(false);
    this.hiddenFieldsModeControl = new FormControl(false);
    this.devModeAvailable = editorConfigurationProvider.isDevModeAvailable() && rsConfig.showDevMode();
    this.isRS = editorConfigurationProvider.isRS();

    this.subscribeToDevModeChanges();
    this.subscribeToSupportModeChanges();
    this.subscribeToSuperEditModeChanges();
    this.subscribeToHiddenFieldsModeChanges();
  }

  private subscribeToDevModeChanges() {
    this.subscriptions.add(
      this.stateService.getDevMode().subscribe(nextDevMode => {
        if (!this.devModeAvailable && nextDevMode) {
          this.devModeControl.setValue(false, { emitEvent: false });
          this.stateService.setDevMode(false);
        } else {
          this.devModeControl.setValue(nextDevMode);
        }
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.devModeControl.valueChanges.subscribe(value => {
        this.stateService.setDevMode(value);
        this.cdRef.markForCheck();
      })
    );
  }

  private subscribeToSuperEditModeChanges() {
    this.subscriptions.add(
      this.stateService.getSuperEditMode().subscribe(nextSuperEditMode => {
        this.superEditModeControl.setValue(nextSuperEditMode, { emitEvent: false });
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.superEditModeControl.valueChanges.subscribe(value => {
        this.stateService.setSuperEditMode(value);
        this.cdRef.markForCheck();
      })
    );
  }

  private subscribeToSupportModeChanges() {
    this.subscriptions.add(
      this.stateService.getSupportMode().subscribe(nextSupportMode => {
        this.supportModeControl.setValue(nextSupportMode, { emitEvent: false });
        this.superEditModeAvailable = nextSupportMode && this.rsConfig.showSuperEditMode();
        if (!nextSupportMode) {
          this.stateService.setSuperEditMode(false);
        }

        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.supportModeControl.valueChanges.subscribe(value => {
        this.stateService.setSupportMode(value);
        this.cdRef.markForCheck();
      })
    );
  }

  private subscribeToHiddenFieldsModeChanges() {
    this.subscriptions.add(
      this.stateService.getHiddenFieldsMode().subscribe(nextForbiddenMode => {
        this.hiddenFieldsModeControl.setValue(nextForbiddenMode, { emitEvent: false });
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.hiddenFieldsModeControl.valueChanges.subscribe(value => {
        this.stateService.setHiddenFieldsMode(value);
        this.cdRef.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
